module.exports = "https://static.im-cdn.com/mjc/storefront/Runway/static/media/Fb.525c31cb.svg";